import { StringUtils } from '../utils/StringUtils'

export class ChatAttachment {
  public static readonly ATTACHMENT_TYPE_IMG = 'IMG'
  public static readonly ATTACHMENT_TYPE_VIDEO = 'VIDEO'
  public static readonly ATTACHMENT_TYPE_AUDIO = 'AUDIO'
  public static readonly ATTACHMENT_TYPE_DOCUMENT = 'DOCUMENT'

  public id: number|null = null;
  public uuid: string|null = null;
  public type: string|null = null;
  public source: string|null = null;
  public rawFile: File|null = null;
  public rawFileName: string|null = null;
  public cacheParameter: string|null = null

  public uploadedChunkBytes = 0;
  public uploaded = false
  public uploadStarted = false

  constructor () {
    this.uuid = StringUtils.generateUUID()
  }

  public static isFileImage (file: File): boolean {
    return file.type.startsWith('image')
  }

  public static isFileVideo (file: File): boolean {
    return file.type.startsWith('video')
  }

  public static isFileAudio (file: File): boolean {
    return file.type.startsWith('audio')
  }

  public static isFileDocument (file: File): boolean {
    return file.type === 'application/pdf'
  }

  static dbToStringType (type: number): string {
    switch (type) {
      case 0:
        return ChatAttachment.ATTACHMENT_TYPE_IMG
      case 1:
        return ChatAttachment.ATTACHMENT_TYPE_VIDEO
      case 2:
        return ChatAttachment.ATTACHMENT_TYPE_AUDIO
      case 3:
        return ChatAttachment.ATTACHMENT_TYPE_DOCUMENT
      default:
        return 'unknown type in database: ' + type
    }
  }
}
